export default "__VITE_ASSET__UgvJw9pe__"